module.exports = __webpack_public_path__ + "static/media/phone_notif_2x.97d45a52.png";